import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { RequestProcessingService } from '../services/request-processing.service';
import { RequestProcessingTable, TwoWayRequestProcessingFieldName } from '../services/request-processing.types';

@Injectable()
export class RequestProcessingListingDataSourceService implements ListingDataSource<RequestProcessingTable> {
  private readonly requestProcessingService = inject(RequestProcessingService);
  private readonly tz = inject(TimezoneService);

  total = 0;

  getAll(tableState: ListingPayload): Observable<RequestProcessingTable> {
    return this.requestProcessingService.getTableData({
      ...tableState,
      filters: [
        ...(tableState.filters ?? []).map(f => ({
          ...f,
          filteredValues: [
            TwoWayRequestProcessingFieldName.EndDateTimeUtc,
            TwoWayRequestProcessingFieldName.ScheduledDateTimeUtc,
            TwoWayRequestProcessingFieldName.StartDateTimeUtc
          ].includes(f.filterType)
            ? this.tz.getShiftedDatepickerRangeStringified({
                start: new Date(f.filteredValues[0]),
                end: new Date(f.filteredValues[1])
              })
            : f.filteredValues
        }))
      ]
    });
  }
}
